import { TabItem, TabList } from "../../Pages/Broadcast/styles";
import { Container } from "../../Styles/global";
import * as React from "react";
import WebhooksTable from "./webhooks-table";
import DiagnosticsTable from "./diagnostics-table";
import ZapierWebhooksTable from "./zapier-webhooks-table";
import APIKeysTable from "./api-keys-table";

const WebhooksSettings = () => {
	const [visibleTab, setVisibleTab] = React.useState("webhooks");

	const toggleContent = (type) => {
		switch (type) {
			case "webhooks":
				setVisibleTab("webhooks");
				break;
			case "diagnostics":
				setVisibleTab("diagnostics");
				break;
			case "apiKeys":
				setVisibleTab("apiKeys");
				break;
			default:
				break;
		}
	};
	return (
		<Container>
			<div>
				<TabList>
					<TabItem
						onClick={() => {
							toggleContent("webhooks");
						}}
						active={visibleTab === "webhooks"}
					>
						Webhooks
					</TabItem>
					<TabItem
						onClick={() => {
							toggleContent("diagnostics");
						}}
						active={visibleTab === "diagnostics"}
					>
						Diagnostics
					</TabItem>
					<TabItem
						onClick={() => {
							toggleContent("apiKeys");
						}}
						active={visibleTab === "apiKeys"}
					>
						API Keys
					</TabItem>
				</TabList>
			</div>
			<div>
				{visibleTab === "diagnostics" ? (
					<DiagnosticsTable />
				) : visibleTab === "webhooks" ? (
					<>
						<WebhooksTable />
						<h2>Zapier Webhook I've set up</h2>
						<ZapierWebhooksTable />
					</>
				) : <APIKeysTable/>}
			</div>
		</Container>
	);
};

export default WebhooksSettings;
